<div class="center">
  <p>Redirection en cours ...</p>
  <mat-spinner></mat-spinner>
</div>
